import * as React from 'react'
import * as Reakit from 'reakit/Tooltip'

import { TooltipArrow } from './tooltip-arrow'
import { TooltipBox, TooltipBoxProps } from './tooltip-box'

interface TooltipProps extends TooltipBoxProps {
  /**
   * The returned object from `useTooltipState`
   */
  state: Reakit.TooltipStateReturn
}

export function Tooltip({ state, children, color = 'none', ...props }: React.PropsWithChildren<TooltipProps>) {
  return (
    <Reakit.Tooltip {...state}>
      {({ onTransitionEnd, onAnimationEnd, ...tooltipProps }) => (
        <div {...tooltipProps} className="finviz-popover z-dialog outline-none">
          <TooltipBox
            {...props}
            color={color}
            onTransitionEnd={onTransitionEnd}
            onAnimationEnd={onAnimationEnd}
            data-placement={state.placement}
          >
            <Reakit.TooltipArrow {...state} size={11}>
              <TooltipArrow placement={state.placement} color={color} />
            </Reakit.TooltipArrow>
            {children}
          </TooltipBox>
        </div>
      )}
    </Reakit.Tooltip>
  )
}
